import { render, staticRenderFns } from "./BusinessLicense.vue?vue&type=template&id=72641f78&scoped=true"
import script from "./BusinessLicense.vue?vue&type=script&lang=js"
export * from "./BusinessLicense.vue?vue&type=script&lang=js"
import style0 from "./BusinessLicense.vue?vue&type=style&index=0&id=72641f78&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72641f78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72641f78')) {
      api.createRecord('72641f78', component.options)
    } else {
      api.reload('72641f78', component.options)
    }
    module.hot.accept("./BusinessLicense.vue?vue&type=template&id=72641f78&scoped=true", function () {
      api.rerender('72641f78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/BusinessLicense.vue"
export default component.exports